import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useTranslation } from "react-i18next";

gsap.registerPlugin(ScrollTrigger);

export default function Palette() {
  const containerRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top 75%",
          end: "bottom top",
          toggleActions: "play none none reverse",
        },
      });

      const coloTitle = containerRef.current.querySelector(".colo-title");
      const typoTitle = containerRef.current.querySelector(".typo-title");
      const coloGrid = containerRef.current.querySelector(".colo-grid");
      const coloDivs =
        containerRef.current.querySelectorAll(".colo-grid > div");
      const textTypo = containerRef.current.querySelector(".Text-Typo");
      const jaqueName = containerRef.current.querySelector(
        ".typo-block.jaque .typo-name"
      );
      const jaqueLines = containerRef.current.querySelectorAll(
        ".typo-block.jaque .typo-line"
      );
      const mindlineName = containerRef.current.querySelector(
        ".typo-block.mindline .typo-name"
      );
      const mindlineLines = containerRef.current.querySelectorAll(
        ".typo-block.mindline .typo-line"
      );

      tl.fromTo(
        coloTitle,
        { opacity: 0, y: 20, filter: "blur(2px)" },
        {
          opacity: 1,
          y: 0,
          filter: "blur(0px)",
          duration: 0.6,
          ease: "power2.out",
        }
      )
        .fromTo(
          typoTitle,
          { opacity: 0, y: 20, filter: "blur(2px)" },
          {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 0.6,
            ease: "power2.out",
          },
          "-=0.48"
        )
        .fromTo(
          coloGrid,
          { opacity: 0, y: 20, filter: "blur(2px)" },
          {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 0.6,
            ease: "power2.out",
          },
          "-=0.42"
        )
        .fromTo(
          coloDivs,
          { opacity: 0, y: 20, filter: "blur(2px)" },
          {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 0.6,
            ease: "power2.out",
            stagger: 0.12,
          },
          "-=0.3"
        )
        .fromTo(
          textTypo,
          { opacity: 0, y: 20, filter: "blur(2px)" },
          {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 0.6,
            ease: "power2.out",
          },
          "-=0.14"
        )
        .fromTo(
          jaqueName,
          { opacity: 0, y: 20, filter: "blur(2px)" },
          {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 0.6,
            ease: "power2.out",
          },
          "-=0.48"
        )
        .fromTo(
          jaqueLines,
          { opacity: 0, y: 20, filter: "blur(2px)" },
          {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 0.6,
            ease: "power2.out",
            stagger: 0.12,
          },
          "-=0.48"
        )
        .fromTo(
          mindlineName,
          { opacity: 0, y: 20, filter: "blur(2px)" },
          {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 0.6,
            ease: "power2.out",
          },
          "-=0.36"
        )
        .fromTo(
          mindlineLines,
          { opacity: 0, y: 20, filter: "blur(2px)" },
          {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 0.6,
            ease: "power2.out",
            stagger: 0.12,
          },
          "-=0.48"
        );
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <div className="Effet_Mer-palette" ref={containerRef}>
      <h2 className="colo-title">{t("effetMer.palette.colorimetry")}</h2>
      <h2 className="typo-title">{t("effetMer.palette.typography")}</h2>

      <div className="colo-grid">
        <div></div>
        <div></div>
        <div></div>
      </div>

      <div className="Text-Typo">
        <div className="typo-block jaque">
          <p className="typo-name">JAQUE</p>
          <p className="typo-line typo-uc">ABC</p>
          <p className="typo-line typo-lc">abc</p>
          <p className="typo-line typo-num">123</p>
        </div>

        <div className="typo-block mindline">
          <p className="typo-name">Mindline Slant Demo</p>
          <p className="typo-line typo-uc">ABC</p>
          <p className="typo-line typo-lc">abc</p>
          <p className="typo-line typo-num">123</p>
        </div>
      </div>
    </div>
  );
}
